import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isLoggedIn, loginPathForCurrentUser } from "../utils/authToken";

// Keeps unauthenticated visitors out of the application routes. The backend is
// the real gate; this only spares the user a screen that loads and then fails
// every one of its API calls.
//
// Usable two ways:
//   <Route element={<RequireAuth />}> ...protected routes... </Route>   (layout)
//   <RequireAuth><Thing /></RequireAuth>                               (wrapper)
export default function RequireAuth({ children }) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return (
      <Navigate
        to={loginPathForCurrentUser()}
        replace
        state={{ from: location }}
      />
    );
  }

  return children ? children : <Outlet />;
}
